import { Card } from "antd"
import { Event} from "../api.types"
import { GameEntryView } from "../model/gameEntryView"

export function EventSocialsHelper(props: { eventId?: string, event?: Event, gameEntries: GameEntryView[] }) {
    if (!props.eventId || !props.event) {
        return null
    }
    return (<>
        <Card>
            <div>
                Formularz propozycji na kolejne granie<br />
                {props.event.short ? <>https://bgp.krol.me/s/{props.event.short}<br /></> : null}
                {`https://bgp.krol.me/event/${props.eventId}`}
            </div>
            {renderGamesIn(props.event, props.gameEntries)}
        </Card>
    </>)
}


const renderGamesIn = (event: Event | undefined, gameEntries: GameEntryView[]) => {
    if (event && event.status === "done") {
        return <><hr /><div>
            {
                gameEntries.filter((e) => { return e.dropOff !== true }).map((e) => e.name).join(", ")
            }
        </div></>
    }
    return undefined
}
